import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { selectFilterData, setFilterSettings } from "../redux/reportSlice";
import getJsonFromApi from "../Common/getJsonFromApi";
import { useEffect, useState } from "react";

export default function SelectFilter(props) {
  const [data, setData] = useState();
  const {
    options,
    optionsDataSource,
    optionValueProperty,
    optionLabelProperty,
    name,
    label,
    isMulti,
  } = props;
  const dispatch = useDispatch();
  const onChange = (selectedOptions) => {
    dispatch(
      setFilterSettings({ name, value: selectedOptions.map((o) => o.value) })
    );
  };
  //const options = filterData && filterData[name] ? filterData[name] : [];
  const optionsToUse = optionsDataSource ? data : options;

  useEffect(() => {
    const fetchData = async () => {
      const result = await getJsonFromApi(optionsDataSource);
      const optionsFromServer = result.map((i) => {
        return {
          value: i[optionValueProperty],
          label: i[optionLabelProperty],
        };
      });
      setData(optionsFromServer);
    };
    if (optionsDataSource) {
      fetchData();
    }
  }, [optionsDataSource, optionValueProperty, optionLabelProperty]);

  return !optionsToUse ? null : (
    <div
      className={"form-group"}
      data-filter-state={data ? "notloaded" : "loaded"}
      data-filter-name={name}
    >
      <label htmlFor={name}>{label}:</label>
      <Select
        onChange={onChange}
        name={name}
        inputId={name}
        options={optionsToUse}
        isMulti={isMulti}
        closeMenuOnSelect={false}
      />
    </div>
  );
}
